import React from "react";
import { BsTelephonePlus } from "react-icons/bs";
import { AiOutlineMail } from "react-icons/ai";

const QuickContactBanner = () => {
  return (
    <section className="py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-gradient-to-r from-slate-900 via-[#0B2239] to-slate-900 rounded-3xl text-white p-8 sm:p-12 border border-slate-800 shadow-xl flex flex-col md:flex-row justify-between items-center gap-8">
          <div className="flex items-center gap-5">
            <div className="w-14 h-14 rounded-2xl bg-white/10 border border-white/20 flex items-center justify-center text-[#EB4438] shrink-0">
              <BsTelephonePlus className="text-2xl" />
            </div>
            <div>
              <p className="text-slate-400 text-xs uppercase tracking-wider font-semibold">
                Phone Number
              </p>
              <a
                href="tel:+8801941422183"
                className="font-bold text-lg sm:text-xl text-white mt-0.5 hover:text-[#EB4438] transition-colors block"
              >
                +8801941422183
              </a>
            </div>
          </div>

          <div className="hidden md:flex items-center justify-center">
            <span className="px-4 py-1.5 rounded-full bg-white/10 border border-white/20 text-xs font-bold text-slate-300">
              OR
            </span>
          </div>

          <div className="flex items-center gap-5">
            <div className="w-14 h-14 rounded-2xl bg-white/10 border border-white/20 flex items-center justify-center text-[#EB4438] shrink-0">
              <AiOutlineMail className="text-2xl" />
            </div>
            <div>
              <p className="text-slate-400 text-xs uppercase tracking-wider font-semibold">
                Email Address
              </p>
              <a
                href="mailto:moin_dynamic201718@yahoo.com"
                className="font-bold text-sm sm:text-base text-white mt-0.5 hover:text-[#EB4438] transition-colors block"
              >
                moin_dynamic201718@yahoo.com
              </a>
              <a
                href="mailto:moin@dynamic-exim.com"
                className="font-medium text-xs sm:text-sm text-slate-300 hover:text-white transition-colors block"
              >
                moin@dynamic-exim.com
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default QuickContactBanner;

